import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { SegmentUpdateInput } from "@colab/shared";

export type UpdateSegmentInput = {
  id: string;
  patch: SegmentUpdateInput;
};

// PATCH /api/settings/segments/:id
//
// Replaces revalidatePath("/admin/settings/segments/${id}") +
// revalidatePath("/admin/settings/segments") from the legacy action. The
// worker re-fetches the row's entity_type to scope filter validation.
export function useUpdateSegment() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, UpdateSegmentInput>({
    mutationFn: ({ id, patch }) =>
      apiFetch<{ ok: true }>(`/settings/segments/${id}`, {
        method: "PATCH",
        body: JSON.stringify(patch),
      }),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.segments() });
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.segment(id) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to update segment");
    },
  });
}
